import React from 'react'
import styled from 'styled-components'
import {FormattedMessage} from "react-intl";
import DOMPurify from 'dompurify';

// max-width: 35rem;
const StyledSupportMessage = styled.div `
  text-align: center;
  color: rgba(0,0,0,0.4);
  padding: 0.75rem 0 1rem;
  font-weight: 600;
  max-width: 40rem;
  margin: auto;
  a {
    text-decoration;
    color: rgba(0,0,0,0.4);
    :hover {
      color: rgba(0,0,0,0.6);
    }
  }
`


export const SupportMessage = ({system}) =>
  system.labels.supportContact
  ? <StyledSupportMessage dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(system.labels.supportContact)}}/>
  : <StyledSupportMessage><FormattedMessage
      defaultMessage='Need support? Call (800) 501-1537 or email <email>support@purview.net</email>'
      description="Support message"
    values={{
      email: chunks => <a href="mailto:support@purview.net">{chunks}</a>
    }}
    /></StyledSupportMessage>